  <button 
    class="btn-primary rounded-3 d-flex align-items-center gap-1"
    @click="$emit('open-assistant')"
  >
    <i class="bi bi-robot fs-6"></i>
    <span class="text-xs">NPI Assist</span>
  </button>
